import { render, staticRenderFns } from "./dangerousGoodDetailsDialog.vue?vue&type=template&id=7d7c7837&scoped=true"
import script from "./dangerousGoodDetailsDialog.vue?vue&type=script&lang=js"
export * from "./dangerousGoodDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodDetailsDialog.vue?vue&type=style&index=0&id=7d7c7837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7c7837",
  null
  
)

export default component.exports